import { render } from "./WikiImagePicker.vue?vue&type=template&id=64647674"
import script from "./WikiImagePicker.vue?vue&type=script&lang=js"
export * from "./WikiImagePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__